import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=1fdc8c8a&scoped=true"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"
import style0 from "./Tools.vue?vue&type=style&index=0&id=1fdc8c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc8c8a",
  null
  
)

export default component.exports